module.exports = __webpack_public_path__ + "img/luxiang.7ce23fef.png";